import api from '@/services/Api';

class Revisions {
  /**
   * @returns {AxiosPromise<any>}
   */
  static all(conferenceId) {
    return api.get(`/conferences/${conferenceId}/revisions`);
  }

  /**
   * Create a single Conference Revision
   * @returns {AxiosPromise<any>}
   */
  static update(conferenceId, payload) {
    return api.put(`/conferences/${conferenceId}/revisions/${payload.id}`, payload);
  }

  /**
   * Create a single Conference Revision
   * @returns {AxiosPromise<any>}
   */
  static updateStatus(conferenceId, payload) {
    return api.post(`/conferences/${conferenceId}/revisions/${payload.id}/status`, payload);
  }
}

export default Revisions;
